import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';

const CookieDropdown = () => {
  const [cookieType, setCookieType] = useState('');
  const [otherType, setOtherType] = useState('');

  const handleCookieTypeChange = (event) => {
    setCookieType(event.target.value);
  };

  const handleOtherTypeChange = (event) => {
    setOtherType(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="cookie-type-label">Cookie Type</InputLabel>
      <Select
        labelId="cookie-type-label"
        id="cookie-type-select"
        value={cookieType}
        label="Cookie Type"
        onChange={handleCookieTypeChange}
      >
        <MenuItem value="Variety">Variety</MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </Select>
      {cookieType === 'Other' && (
        <TextField
          id="other-cookie-type"
          label="Please specify"
          value={otherType}
          onChange={handleOtherTypeChange}
          margin="normal"
          fullWidth
        />
      )}
    </FormControl>
  );
};

export default CookieDropdown;